var lib_core = require("lib-core");

var TrayAssetUpdateTabView = function(model, statemachine, rootStateMachine, parentView, parentName) {
    var self = this;

    this.model = model;
    this.statemachine = statemachine;
    this.rootStateMachine = rootStateMachine;
    this.parentView = parentView;
    this.parentName = parentName;

    //asset tray list view config
    this.viewConfig = {
        columns: [
        {   name: 'Name',
            key: 'name',
            isLink: true
        }, {
            name: 'Date',
            key: 'updated_at',
            location: 'right'
        }, {
            name: 'User',
            key: 'user_name',
            location: 'right'
        }, {
            name: 'Used',
            key: 'used', //Need to confirm which key to be used (score or used)
            location: 'right'
        }],

        helpView: {
            enable: true,
            message: {
                title: 'Can’t find what you are looking for?',
                expand: 'Expand your search to <a class="js-editor__tray__cannotfind__all_link">All</a> or <a class="js-editor__tray__cannotfind__create_link">create a new one</a>.',
                more_info: 'For more information, visit the <a class="js-editor__tray__cannotfind__doc_center">Documentation Center</a>.'
            }
        },

        enableAssetDetails: true,
        enableSorting: true,
        darkThumbs: ((this.model.type() == "footprints" || this.model.type() == "packages") ? true : false)
    };

    // TITLE
    this.titleTemplate = this.parentView.getTemplate().addTitle(this.model.title());
    this.titleTemplate.$el.on('Cioui:TrayTabTitle:clicked', function(e, val){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_ACTIVE_CHANGE)
            .data('tabName', self.model.name())
            .data('parentName', self.parentName);
        self.statemachine.handle(cEvent);
    });

    // Attach template listeners
    this.attachListeners();

    // OBERVERS
    self.model.data.onChange("dataChange", function(){
        self.showTabData(self);
    });

    self.model.template.onChange("templateChange", function(){
        self.getTemplate().$el.off();
        self.getTemplate().$el.remove();
        self._template = false;
        self.showTabData(self);
        self.attachListeners();

        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_TEMPLATE_SWITCHER_BUTTON_CHANGE)
            .data('alternative_template', self.model.alternative_template())
            .data('parentName', self.parentName);
        self.statemachine.handle(cEvent);
    });

    self.model.sorting.onChange("sortingChange", function(){
        self.getTemplate().setSortingKeyActive(self.model.sorting());
        self.getTemplate().flipSortingArrow(self.model.sorting(), self.model.sorting_direction());
        self.getTemplate().setDropdown(self.model.sorting(), self.model.sorting_direction());
    });

    self.model.visible.onChange("visibleChange", function(member, old, value){
        if(value){
            self.show();
            self.titleTemplate.setActive();
        }else{
            self.hide();
            self.titleTemplate.setInActive();
        }
    });

};

TrayAssetUpdateTabView.prototype.attachListeners = function(){
    var self = this;

    // SORTING
    this.getTemplate().$el.on('Cioui:TrayTabItem:Sort:clicked', function(e, val){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_SORT)
            .data('tabName', self.model.name())
            .data('sortingKey', val)
            .data('parentName', self.parentName);
        self.statemachine.handle(cEvent);
    });

    this.getTemplate().$el.on('Cioui:TrayTabItem:SortDropdown:change', function(e, val){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_SORT)
            .data('tabName', self.model.name())
            .data('sortingKey', val["sortkey"])
            .data('sortingDir', val["sortdirection"])
            .data('parentName', self.parentName);
        self.statemachine.handle(cEvent);
    });
};

TrayAssetUpdateTabView.prototype.getTemplate = function(){
    if(!this._template){
        if(this.model.template() == "list"){
            this._template = this.parentView.getTemplate().addListComponentsInnerTray(this.viewConfig);
        }else if(this.model.template() == "grid"){
            this._template = this.parentView.getTemplate().addGridComponentsInnerTray(this.viewConfig);
        }else{
            console.error("ERROR: Unknown tray tab template");
        }
    }

    return this._template;
};

TrayAssetUpdateTabView.prototype.showTabData = function(ref){

    ref.getTemplate().clearContent();

    if(!ref.model.data()) return;

    if(ref.model.template() == "list") ref.getTemplate().setTotalNumberOfResults(ref.model.numberOfResults());

    $.each(ref.model.data(), function(index, element){
        var updated_at = (element["updated_at"] || false);

        var component = ref.getTemplate().addItem(
            {
                "name": (element["name"] || false),
                "description": (element["description"] || false),
                "thumb_url": (element["thumbnail"] || false),
                "updated_at": updated_at,
                "user_name": (element["user_name"] || false)
            }
        );

        component.$el.on('Cioui:TrayTabItem:clicked', function(e, val){
            var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.NODE_MOUSE_DOWN)
                .data('type', ref.model.type())
                .data('content_server_id', element["id"]);
            ref.model.parent().parent().visible(false); // TODO: violation of MVC!!!!
            ref.rootStateMachine.handle(cEvent);
        });
    });
};


TrayAssetUpdateTabView.prototype.show = function(){
    this.getTemplate().show();
};

TrayAssetUpdateTabView.prototype.hide = function(){
    this.getTemplate().hide();
};

module.exports = TrayAssetUpdateTabView;

